export const youth_policy = `
<h1>청소년보호정책</h1>
<p style="margin-top: 15px">
    '퍼스널뉴스서비스'(이하 ‘회사’라 함)는 각종 청소년유해정보로부터 청소년을 보호하고자 
    관련법률에 따라 19세미만의 청소년들이 유해정보에 접근할 수 없도록 청소년보호정책을 마련하여 시행하고 있습니다. 
    또한 회사는 청소년의 건전한 성장을 저해하는 음란, 불법 등의 유해정보와 비윤리적, 반사회적 행위에 대해서는 
    엄격하게 제재하기 위하여 다음과 같이 활동하고 있습니다. 
</p>

<ul style="margin-top: 15px">
    <li>1조 유해정보로부터 청소년보호계획 수립 및 업무담당자 교육시행</li>
    <li>2조 유해정보에 대한 청소년접근제한 및 관리조치</li>
    <li>3조 유해정보로 인한 피해상담 및 고충처리</li>
    <li>4조 청소년보호책임자 및 담당자 연락법</li>
    <li>5조 부칙</li>
</ul>

<h2 style="margin-top: 15px">제 1 조 유해정보로부터 청소년보호계획 수립 및 업무담당자 교육시행</h2>
<p>
회사는 청소년이 아무런 제한장치 없이 청소년 유해정보에 노출되지 않도록 청소년유해매체물에 대해서는 별도의 인증장치를 마련, 
적용하며 청소년 유해정보가 노출되지 않기 위한 예방차원의 조치를 강구하고 있으며 해당 담당자에 대한 청소년보호교육을 실시합니다.
</p>

<h2 style="margin-top: 15px">제 2 조 유해정보에 대한 청소년접근제한 및 관리조치</h2>
<p>회사는 청소년이 아무런 제한장치 없이 청소년 유해정보에 노출되지 않도록 청소년유해매체물에 대해서는 별도의 인증장치를 마련, 적용하며 청소년 유해정보가 노출되지 않기 위한 예방차원의 조치를 강구합니다.</p>

<h2 style="margin-top: 15px">제 3 조 유해정보로 인한 피해상담 및 고충처리</h2>
<p>회사는 청소년 유해정보로 인한 피해상담 및 고충처리를 위한 전문인력을 배치하여 그 피해가 확산되지 않도록 하고 있습니다.</p>
<p>이용자 분들께서는 하단에 명시한 회사는 "청소년보호 책임자 및 담당자의 소속, 성명 및 연락처" 사항을 참고하여 전화나 이메일을 통하여 피해상담 및 고충처리를 요청할 수 있습니다.</p>

<h2 style="margin-top: 15px">제 4 조 청소년보호책임자 및 담당자 연락법</h2>
<p>회사는 청소년 보호에 대한 의견수렴 및 불만처리를 담당하는 청소년 보호 책임자 및 담당자를 운영하고 있습니다. 이와 관련하여 문의사항이 있으시면 신속하고 성실하게 답변하여 드리겠습니다.</p>

<p><strong>청소년 보호 책임자</strong></p>
<p>성명(직위): 박석준</p>
<p>전화번호: 031-8039-7035</p>
<p>E-mail: <a href="mailto:sjpark@2digit.io">sjpark@2digit.io</a></p>

<h2 style="margin-top: 15px">제 5 조 부칙</h2>
<p>청소년보호정책 시행일자: 2019-09-14</p>
`
